<template>
  <div class="landing-leading">
        
  </div>
</template>
<script>
export default {
  name: 'landing-leading'
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

    
</style>